export default {
  areaID: {
    value: null,
    options: [],
    required: true,
    state: null
  },
  insuranceID: {
    value: null,
    options: [],
    clearOption: true,
    required: true,
    state: null
  },
  stageID: {
    value: null,
    options: [],
    clearOption: true,
    required: true,
    state: null
  },
  schedulingTypeID: {
    value: null,
    options: [],
    clearOption: true,
    required: false,
    state: null
  },
  name: {
    value: '',
    maxlength: '70',
    required: true,
    state: null
  },
  green: {
    value: '',
    maxlength: '10',
    required: true,
    state: null
  },
  yellow: {
    value: '',
    maxlength: '10',
    required: true,
    state: null
  },
  red: {
    value: '',
    maxlength: '10',
    required: true,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/regulation/lighthouse/lighthouse-form.js